import decodeToken from "./decodeToken";
import { getTokenSilent } from "./ad";

const createTokenStore = () => {
  let tkn = null;
  let refreshInterval;

  const getToken = () => tkn;

  const getUser = () => decodeToken(tkn);

  const isLoggedIn = () => typeof decodeToken(tkn) !== "undefined";

  const setToken = token => {
    tkn = token;
  };

  const refreshToken = () =>
    getTokenSilent()
      .then(token => setToken(token))
      .catch(() => setToken(undefined));

  const checkRefreshNeeded = () => {
    const user = getUser();
    const expiryWindow = 5 * 60 * 1000; // refresh if we're at the last five minutes
    const expDate = user ? new Date(user.exp * 1000 - expiryWindow) : null;
    if (expDate && expDate < new Date()) {
      refreshToken();
    }
  };

  const init = token => {
    setToken(token);
    refreshInterval = setInterval(checkRefreshNeeded, 60 * 1000); // check every minute
  };

  const terminate = () => clearInterval(refreshInterval);

  return {
    init,
    getToken,
    getUser,
    isLoggedIn,
    terminate
  };
};

export default createTokenStore;
